export default "__VITE_ASSET__5Yy0_dES__"